(ns common.gender
  (:require
   [common.util :as cu]))

(defonce genders
         {:female {:translations {:en "Female"}}
          :male   {:translations {:en "Male"}}
          :other  {:translations {:en "Other"}}})

(defonce options
         (->> genders
              (map (fn [[k g-m]]
                     {:key   k
                      :label (->> g-m
                                  :translations
                                  :en)}))))

(defn get-label
  [k]
  (->> options
       (cu/filter-by :key k)
       (first)
       :label))
